<template>
  <PopoverButton @click.stop="onDotsClick">
    <Button
      v-bind="$attrs"
      variant="naked"
      test-id="three-dots"
      class="dots flex-center"
    >
      <DotsIcon width="0.875rem" height="0.5rem" />
    </Button>
  </PopoverButton>
</template>

<script lang="ts" setup>
import { PopoverButton } from "@headlessui/vue";

import { Button } from "@/components/global";
import { DotsIcon } from "@/components/svg";

const emit = defineEmits(['click']);

const onDotsClick = (e: Event) => {
  e.stopPropagation();

  emit('click', e)
}
</script>

<style scoped>
.dots {
  min-width: 1.5rem;
  min-height: 1.25rem;
  background-color: var(--ch-light-grey);
  color: var(--ch-white);
}

.table-container .table-cell-clickable:hover .dots {
  background-color: var(--ch-white);
  color: var(--ch-blue-100);
}
</style>